
import config from '../config.json';

export async function apiGet(url: any) {
    
    try {
        url = `${config.apiEndpoint}` + url;
        const res = await fetch(
            url
            , {
                method: 'GET',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": ""
                },
                //credentials:"include",
                mode: "cors"
            }
        );
        
        const json = await res.json();
        return json;
    } catch (error) {
        return error;
    }

}


export async function apiPost(url: any, body : any) {
    
    try {
        url = `${config.apiEndpoint}` + url;
        const res = await fetch(
            url
            , {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Authorization": ""
                },
                //body: module,
                body: JSON.stringify(body),
                //credentials:"include",
                mode: "cors",
            }
        );
        
        const json = await res.json();
        return json;
    } catch (error) {
        return error;
    }

}